import { choose } from '../../utils/platform';
import PeopleSearchDesktop from './PeopleSearch.desktop';
import PeopleSearchMobile from './PeopleSearch.mobile';

// Platform chooser — logic in usePeopleSearch (exposed as vm.people by useMembers).
export default choose(PeopleSearchDesktop, PeopleSearchMobile);
